import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ENTITY_GET_OPTIONS} from '../../../services/albumProvider/albumProviderConstant';
import {getEntityGetOption} from '../../../services/albumProvider/getOptions';
import {Price} from '../../Price/Price';
import {Button} from '../../ui/Button/Button';

export function GetAlbumButton(props) {
  const {album, onClick, className} = props;
  const {t} = useTranslation();
  const type = getEntityGetOption(album);
  if (type === ENTITY_GET_OPTIONS.NOTHING) {
    return null;
  }
  const label = {
    [ENTITY_GET_OPTIONS.GET]: t('mgw.trackPage.getAlbum'),
    [ENTITY_GET_OPTIONS.DOWNLOAD]: t('mgw.trackPage.downloadAlbum'),
    [ENTITY_GET_OPTIONS.BUY]: (
      <Price price={Number(album.albumPrice)} currency={album.albumCurrency} translationKey="mgw.trackPage.buyAlbum" />
    ),
  }[type];

  return (
    <Button onClick={onClick} className={className} dataHook="get-album-button" disabled={album.demo}>
      {label}
    </Button>
  );
}

GetAlbumButton.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  album: PropTypes.object,
  onClick: PropTypes.func,
};
